/* tslint:disable */
/* eslint-disable */
/**
 * UniCatDB API
 * UniCatDB application API documentation, with examples and live testing.  This API is built in accordance with the **JSON API 1.0 standard**. For general information, see [the documentation](http://jsonapi.org/format/).  -  JSON API standard requires use of the JSON API media type (application/vnd.api+json) for exchanging data. Clients must send all JSON API data with the headers `Content-Type: application/vnd.api+json` (POST, PATCH) and `Accept: application/vnd.api+json` (GET, DELETE). - [Relationships](http://jsonapi.org/format/#fetching-relationships) and their [inclusions](http://jsonapi.org/format/#fetching-includes) via the `include` query parameter, as specified by the standard, **are not implemented**, since there are no relationships present in the data model. - The standard does not prescribe any filtering strategies. This API implements two strategies which can be combined: **Basic filtering** based on the used [JSON API library](https://json-api-dotnet.github.io/#/filtering) and **Custom filtering** which allow for any possible query to the MongoDB server and can be extended and customize in the future. For more information about filtering, see the description of the `filter` down bellow. - **Non-standard PATCH behavior:** Sucessfull PATCH reuest always result in HTTP 200 response with the updated resource object, even if the server does not perform any additional modifications. HTTP 204 is never used in PATCH responses.  Attachment upload endpoint uses the **TUS protocol**. See [the documentation](https://tus.io/). When integrating, it is recommended to use one of the [official TUS client implementations](https://tus.io/implementations.html).  - **Supported TUS versions**:   -  1.0.0 - **Supported TUS extensions**:   - Creation   - Creation Defer Length   - Creation With Upload   - Checksum   - Checksum Trailer - **Required metadata**:   - `fileName` - name of the original file incl. file extension   - `contentType`- the MIME type of the file 
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FindingSchemaElementValue,
    FindingSchemaElementValueFromJSON,
    FindingSchemaElementValueFromJSONTyped,
    FindingSchemaElementValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface FindingSchemaElement
 */
export interface FindingSchemaElement {
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    subtype?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FindingSchemaElement
     */
    required?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    placeholder?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FindingSchemaElement
     */
    other?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FindingSchemaElement
     */
    multiple?: boolean;
    /**
     * 
     * @type {Array<FindingSchemaElementValue>}
     * @memberof FindingSchemaElement
     */
    values?: Array<FindingSchemaElementValue>;
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    min?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    max?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    step?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    maxlength?: string;
    /**
     * 
     * @type {string}
     * @memberof FindingSchemaElement
     */
    className?: string;
}

export function FindingSchemaElementFromJSON(json: any): FindingSchemaElement {
    return FindingSchemaElementFromJSONTyped(json, false);
}

export function FindingSchemaElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingSchemaElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'subtype': !exists(json, 'subtype') ? undefined : json['subtype'],
        'required': !exists(json, 'required') ? undefined : json['required'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'placeholder': !exists(json, 'placeholder') ? undefined : json['placeholder'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'other': !exists(json, 'other') ? undefined : json['other'],
        'multiple': !exists(json, 'multiple') ? undefined : json['multiple'],
        'values': !exists(json, 'values') ? undefined : ((json['values'] as Array<any>).map(FindingSchemaElementValueFromJSON)),
        'min': !exists(json, 'min') ? undefined : json['min'],
        'max': !exists(json, 'max') ? undefined : json['max'],
        'step': !exists(json, 'step') ? undefined : json['step'],
        'maxlength': !exists(json, 'maxlength') ? undefined : json['maxlength'],
        'className': !exists(json, 'className') ? undefined : json['className'],
    };
}

export function FindingSchemaElementToJSON(value?: FindingSchemaElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'subtype': value.subtype,
        'required': value.required,
        'label': value.label,
        'description': value.description,
        'placeholder': value.placeholder,
        'name': value.name,
        'other': value.other,
        'multiple': value.multiple,
        'values': value.values === undefined ? undefined : ((value.values as Array<any>).map(FindingSchemaElementValueToJSON)),
        'min': value.min,
        'max': value.max,
        'step': value.step,
        'maxlength': value.maxlength,
        'className': value.className,
    };
}


